export default "__VITE_ASSET__CDGnceJd__"